import type { Translations } from '../types';

export const zhTW: Translations = {
    common: {
        save: '儲存',
        cancel: '取消',
        delete: '刪除',
        edit: '編輯',
        add: '新增',
        loading: '載入中...',
        error: '錯誤',
        success: '成功',
        confirm: '確認',
        yes: '是',
        no: '否',
        search: '搜尋',
        noResults: '無結果',
        refresh: '重新整理',
        logout: '登出',
        settings: '設定',
        download: 'Download',
    },
    nav: {
        chat: '聊天',
        gallery: '圖庫',
        settings: '設定',
        admin: '管理',
        users: '使用者',
        models: '模型',
    },
    auth: {
        login: '登入',
        register: '註冊',
        username: '使用者名稱',
        password: '密碼',
        currentPassword: '目前密碼',
        newPassword: '新密碼',
        confirmPassword: '確認密碼',
        loginButton: '登入',
        registerButton: '註冊',
        loggingIn: '登入中...',
        invalidCredentials: '使用者名稱或密碼錯誤',
        changePassword: '變更密碼',
        changingPassword: '變更中...',
        passwordChanged: '密碼已變更。其他裝置已登出。',
        invalidateAllSessions: '登出所有裝置',
        allSessionsInvalidated: '所有工作階段已失效。請重新登入。',
    },
    chat: {
        newChat: '新聊天',
        sendMessage: '傳送',
        typeMessage: '輸入訊息...',
        noChats: '暫無聊天',
        startNewChat: '開始新聊天',
        deleteChat: '刪除聊天',
        deleteChatConfirm: '確定刪除此聊天？',
        deleteMessages: '刪除訊息',
        deleteMessageConfirm: '確定刪除此訊息？',
        exportChat: '匯出聊天',
        importChat: '匯入聊天',
        selectModel: '選擇模型',
        thinking: '思考中...',
    },
    gallery: {
        title: '圖庫',
        description: '管理生成的圖片和影片',
        upload: '上傳',
        dragDrop: '拖放檔案上傳',
        delete: '刪除',
        move: '移動',
        sync: '同步',
        noFiles: '暫無檔案',
        syncComplete: '同步完成',
        uploadComplete: '上傳完成',
        deleteConfirm: '確定刪除所選檔案？',
        newFolder: '新增資料夾',
        path: '路徑',
        filename: '檔案名',
        no_metadata: '無元數據',
        model: '模型',
        seed: '種子',
        size: '尺寸',
        sampler: '取樣器',
        prompt: '提示詞',
        negative_prompt: '負面提示詞',
        ai_analyze: 'AI聊天分析',
        mode_image: '僅圖片',
        mode_prompt: '僅提示詞',
        mode_both: '圖片+提示詞',
        apply_settings: '應用生成設定',
    },
    settings: {
        title: '設定',
        apiKey: 'Google API金鑰',
        apiKeyDesc: '用於Gemini API的API金鑰',
        apiKeyPlaceholder: '以AIza開頭的API金鑰',
        apiKeySaved: 'API金鑰已儲存。',
        apiKeyRemoved: 'API金鑰已刪除。',
        removeApiKey: '刪除API金鑰',
        r2Config: 'R2儲存設定',
        r2ConfigDesc: 'Cloudflare R2儲存設定',
        r2Configured: 'R2已設定',
        r2SaveSuccess: 'R2設定已儲存。',
        r2ChangeHint: '要變更R2設定，請重新填寫以下表單。',
        autoSave: '自動儲存媒體',
        autoSaveDesc: '自動將生成的圖片/影片儲存到R2',
        chatBackup: '聊天備份',
        exportAll: '匯出全部',
        importAll: '匯入全部',
        backupDesc: '將所有聊天和訊息備份或恢復為JSON檔案。',
        backupSuccess: '備份完成。',
        backupFailed: '備份失敗。',
        importSuccess: '匯入完成。',
        importFailed: '匯入失敗。',
        security: '安全性',
        securityDesc: '密碼變更和工作階段管理',
        passwordChangeHint: '變更密碼後，其他裝置的工作階段將自動登出。',
        sessionLogoutHint: '從所有其他裝置登出。',
        systemPrompts: '系統提示詞',
        addPrompt: '新增',
        promptTitle: '標題',
        promptContent: '內容',
        deletePromptConfirm: '確定刪除此提示詞？',
        clearCacheConfirm: '確定清除本機快取？',
        clearCache: '清除快取',
        clearCacheDesc: '確定清除本機快取？UI狀態將被重設。',
        cacheClearedRefresh: '快取已清除。頁面將重新整理。',
    },
    admin: {
        users: {
            title: '使用者管理',
            description: '建立和管理使用者帳戶',
            addUser: '新增使用者',
            username: '使用者名稱',
            password: '密碼',
            role: '角色',
            admin: '管理員',
            user: '使用者',
            createdAt: '建立時間',
            actions: '操作',
            noUsers: '暫無註冊使用者',
            deleteConfirm: '確定刪除此使用者？',
            createFailed: '使用者建立失敗。',
            cannotDeleteSelf: '無法刪除自己。',
            cannotChangeOwnRole: '無法變更自己的角色。',
            passwordMinLength: '密碼至少需要8個字元。',
            passwordChanged: '密碼已變更。',
            resetPassword: '重設密碼',
            newPassword: '新密碼（8位以上）',
            enterNewPassword: '的新密碼：',
        },
        models: {
            title: '模型設定',
            description: '管理提供給使用者的AI模型',
            fetchFromGoogle: '從Google取得',
            fetchModels: '取得模型',
            noModels: '暫無註冊模型',
            noModelsDesc: '點擊「從Google取得」按鈕載入可用模型。',
            active: '啟用',
            inactive: '停用',
            modelsFetched: '模型取得完成',
            fetchFailed: '模型取得失敗。請檢查API金鑰。',
            deleteConfirm: '確定刪除此模型？',
            helpTitle: '說明',
            helpItems: [
                '只有啟用的模型才會顯示給使用者。',
                '「從Google取得」使用設定頁面中儲存的API金鑰。',
                '模型清單由Google Gemini API提供。',
            ],
        },
    },
    time: {
        justNow: '剛剛',
        minutesAgo: '分鐘前',
        hoursAgo: '小時前',
        daysAgo: '天前',
    },
    errors: {
        networkError: '網路錯誤',
        unauthorized: '需要驗證',
        serverError: '伺服器錯誤',
        notFound: '找不到',
        rateLimited: '請求過多，請稍後再試。',
    },
};
